/**
 * @desc flight json modifier and get solution from cache
 */
// TODO: move this file content to utils - karthik
!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/flightSolution',['libs/ct_store', 'vendor/mustache', 'hotels/flCodeToNameMapping'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.Store, CT.Mustache)
}('FlightSolution', function(Store, Mustache){
	CT.FlightSolution = {
		/*
		 * @desc : takes flight solution ( from mapping ) and flight content json and returns solution summary
		 * @param : flSolution - a solution taken from mapping.
		 * @param : flContent - contains all flights content.
		 */
		getSummary: function (flFare, flContent, flSolution, type, solutionIndex, contentArray, jsonsProp) {
			var flDetails = {}, flSegCount, flSegLast, tmp, tmpArr = [],
				inxToTextMap = {
					0: 'first',
					1: 'second',
					2: 'third',
					4: 'fourth',
					5: 'fifth'
				};

			// TODO: uncomment if case - karthik
			//if(!flSolution.summary) {
				//initialize fldetails
				flDetails.ids = '';
				flDetails.logo = [];
				flDetails.stp = "non-stop";


				//modify flight content json and get list of flight ids
				_.forEach(flSolution.c, function(eachContent, index) {
					flDetails.ids += (index != 0 ? ', ':'') + flContent[eachContent].ac;
					if(_.indexOf(tmpArr, flContent[eachContent].oa) < 0) {
						tmp = { nm: flContent[eachContent].nm, oa: flContent[eachContent].oa, cls: inxToTextMap[index] };
						flDetails.logo.push(tmp);
						tmpArr.push(flContent[eachContent].oa);
					}
				}, this);

				flDetails.ccnt = flDetails.logo.length;
				//clone first flight details
				flDetails = $.extend(true, flDetails, flContent[_.first(flSolution.c)]);


				//flight travel time calculator
				tmp = flContent[_.first(flSolution.c)]
				deptTS = tmp = moment(tmp.dpd + tmp.dp, "DDMMYYYYHH:mm");
				flDetails.dpd = tmp.format('ddd, d MMM');

				tmp = flContent[_.last(flSolution.c)]
				arriTS = tmp = moment(tmp.ad + tmp.a, "DD/MM/YYYYHH:mm");
				flDetails.ad = tmp.format('ddd, d MMM');

				//flDetails.dur = moment(arriTS.diff(deptTS)).format('HH\\h mm\\m');
				
				
				if(jsonsProp.searchType.isIntl){
					flDetails.dur = this.calcIntlDuration(contentArray);
				}else{
					flDetails.dur = this.calcDuration(deptTS,arriTS);
				}
				
				//if multiple segments
				if((flSegCount = flSolution.c.length) > 1) {
					flSegLast = flContent[_.last(flSolution.c)];
					//change the arrival date and time to last seg flight date and time
					flDetails.a = flSegLast.a;
					flDetails.stp = (flSegCount-1) + ' ' + (flSegCount-1 == 1 ? "stop":"stops");
				}

				flSolution['summary'] = {};

				_.forEach(['stp', 'ids', 'logo', 'ccnt', 'dp', 'a', 'dur', 'dpd', 'ad', 'oa', 'ac', 'nm', 'cp'], function(eachAttr) {
					flSolution['summary'][eachAttr] = flDetails[eachAttr];
				});

				//add solution index into display content
				if(type == 'onward') {
					flSolution['summary'].foninx = "" + solutionIndex + "";
				} else if(type == 'return') {
					flSolution['summary'].frtinx = "" + solutionIndex + "";
				}

			//}

			return flSolution.summary;

		},

		calcIntlDuration : function(contents){
			var d = 0, layOverDur = 0;
			
			_.each(contents, function(content, idx){
				content.dur = _.getDurationStr(content.dr);
				if(idx>0) {
					var tempdpd = [content.dpd.substr(0,2), content.dpd.substr(2,2), content.dpd.substr(4)], tempdpd = tempdpd.join("/");
					
					layOverDur = _.getDurationInMilliSeconds(CT.utils.swapDayMonth(tempdpd) + ' ' + content.dp, CT.utils.swapDayMonth(contents[idx-1].ad) + ' ' + contents[idx-1].a)/1000;
					//content.ldr = _.getDurationStr(layOverDur); //not supposed to update the content here, only calculation is performed in this function.
					d += layOverDur + content.dr;
				} else {
					d += content.dr;
				}
			})
			d = _.getDurationStr(d);
			
			return d;
		},
		
		calcDuration : function(deptTS,arriTS){
			var hrs,tmpDt,min,dur;
			hrs = arriTS.diff(deptTS,'hours');
			tmpDt = deptTS.add('hours' , hrs);
			min = tmpDt.diff(arriTS, 'minutes');
			if(min > 0){
				min = 60 - min;
				hrs = hrs - 1;
			}
			if(min < 0){
				min = min * -1;
			}
			dur = hrs+"h "+min+"m";
			return dur;
		},



		// @params "flight" is pass by reference and content will be modified
		splitFk: function (flight, isIntl) {
			var keys, keyMap = {
				0: 'cp',
				1: 'ac',
				2: 'dpd',
				3: 'dp'
			};

			keys = flight.fk.split("_");
			if(keys.length == 5) {
				keys[1] = keys[0] + "_" + keys[1];
				keys.splice(0, 1);
			}
			_.forEach(keys, function(key, index) {
				var dashIndex;
				if(keyMap[index] == 'ac') {
					dashIndex = key.lastIndexOf('-');
					key = key.substr(0,dashIndex) + ' ' + key.substr(dashIndex+1);
					fln = key.substr(dashIndex+1);


					//flight name mapping
					//if(isIntl) {
						// TODO: has to be implemented - karthik
					//} else {
						// flight.nm = CT.flCodeToNameMapping[key.split(' ')[0]];
					//}
					//flight.nm = CT.cache[CT.settings.currentTab].json.fl.jsons.airline_names[key.split(' ')[0]];
					flight.nm = CT.masterJson.get().fl.jsons.airline_names[key.split(' ')[0]];
					flight.alCode = key.split(' ')[0];

					if((dashIndex = key.indexOf('-')) >= 0 && key.indexOf("9W-K") != 0) // bypassing this step for 9w-k
						key = key.substr(0,dashIndex) + '' + key.substr(dashIndex+1);
					flight[keyMap[index]] = key;
					flight['fln'] = fln;
				}
				else {
					flight[keyMap[index]] = key;
				}
			});
		},

		modifier : function (masterJson){
			var that = this;

			function getContentAndKey(solution, contents, fares, type, solutionIndex){
				var contentArray = [],fare;
				var fareKey = solution.f, contentKeys = solution.c;
				var fk = "", summary;
				$(contentKeys).each(function(i,key){
					// TODO: need to include international or domestic as last param - karthik
					that.splitFk(contents[key], false);

					contentArray.push(contents[key]);
					fk += "$$" + contents[key].fk
				});
				fare = $.extend(true,{},fares[fareKey]);

				if(fare.R){
					fare.dfd = "R";
				}else if(fare.N){
					fare.dfd = "N";
				}
				if(fare.SPLRT){
					if(fare.SPLRT.R){
						fare.SPLRT.dfd = "R";
					}else if(fare.SPLRT.N){
						fare.SPLRT.dfd = "N";
					}
				}
				summary = that.getSummary(masterJson.fare, masterJson.content, solution, type, solutionIndex, contentArray, masterJson.jsons);

				return {content: contentArray, fk: (fk.substr(2)), fare:fare, summary: summary};
			}


			var _json = $.extend(masterJson);
			$(masterJson.mapping.onward).each(function(i,solution){
				solution = $.extend(solution,getContentAndKey(solution, _json.content, _json.fare, 'onward', i));
			});
			$(masterJson.mapping["return"]).each(function(i,solution){
				solution = $.extend(solution,getContentAndKey(solution, _json.content, _json.fare, 'return', i));
			});

			return _json;
		},

		updateHotelMasterJsonPrice : function(hotelJson,priceOffset){
			var currentTab = CT.settings.currentTab;
			_.forEach(hotelJson,function(hotelMap,index){
				hotelMap.priceInfo.pf = parseInt(hotelMap.priceInfo.pf) + parseInt(priceOffset);
				hotelMap.priceInfo.airpf=parseInt(hotelMap.priceInfo.airpf) + parseInt(priceOffset);
			});
			$.extend(true, CT.masterJson.get().ht, hotelJson);
		},

		updateHotelMasterJsonSavings : function(hotelJson,psOffset){
			var currentTab = CT.settings.currentTab;
			_.forEach(hotelJson,function(hotelMap,index){
				hotelMap.priceInfo.ps = parseInt(hotelMap.priceInfo.ps) + parseInt(psOffset);
				hotelMap.priceInfo.airps = parseInt(hotelMap.priceInfo.airps) + parseInt(psOffset);
			});
			$.extend(true, CT.masterJson.get().ht, hotelJson);
		},

		updateFlightMasterJson : function(jsonMapping,fareIndex,priceOffset){
			var fareIndex = fareIndex;
			var priceOffset = $.extend(true,{},priceOffset);;
			var that = this;
			var currentTab = CT.settings.currentTab;
			_.forEach(jsonMapping.onward,function(_flightMap,index){
				that.updateFlightMasterJsonPrice(_flightMap.fare,"-",priceOffset.onward);
			});

			$.extend(true, CT.masterJson.get().fl.mapping.onward, jsonMapping.onward);
			if(CT.tripType === "domRt"){
				_.each(jsonMapping["return"],function(_flightMap,index){
					that.updateFlightMasterJsonPrice(_flightMap.fare,"-",priceOffset["return"]);
				})
				$.extend(true, CT.masterJson.get().fl.mapping["return"], jsonMapping["return"]);
			}
		},
		updateFlightMasterJsonPrice : function(fr,val,price){
			var isAdd = val === '+';
			var that = this;
			if(fr.R){
			    fr.R.pr = fr.R.pr - price;
			}
			if(fr.N){
				fr.N.pr = fr.N.pr - price;
			}
			if(fr.SPLRT && fr.SPLRT.N){
				fr.SPLRT.N.pr = fr.SPLRT.N.pr - price;
			}
			if(fr.SPLRT && fr.SPLRT.R){
				fr.SPLRT.R.pr = fr.SPLRT.R.pr - price;
			}
		},

		/*getFlightPrice : function(flSolution,options){
			var price,
			isCombo = options.isCombo ? options.isCombo : false,
			isDefaultPrice = options.isDefaultPrice ? options.isDefaultPrice : null;
			if(flSolution.fare.isDefaultPrice){
				price = flSolution.fare.isDefaultPrice === "SPLRT" ? flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd].pr : flSolution.fare[flSolution.fare.isDefaultPrice].pr;
			}else if(flSolution.fare.dfd){
				price = isCombo ? flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd].pr : flSolution.fare[flSolution.fare.dfd].pr;
			}else if(flSolution.fare.SPLRT){
				price = flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd].pr;
			}
			return price;
		},*/
		flightDebuggerOptions : function(flJson,owardIdx,returnIdx,isCombo){
			var sfsfd = (_.deserialize(location.search)).sfsfd ? true : false;
			outFlSumm = flJson.mapping.onward[owardIdx].summary;
			retFlSumm = flJson.mapping['return'][returnIdx].summary;

			outFlfare= flJson.mapping.onward[owardIdx].fare;
			retFlfare= flJson.mapping['return'][returnIdx].fare;

			outFlfb=this.getFb(outFlfare,isCombo);
			retFlfb=this.getFb(retFlfare,isCombo);
			outFlSumm.fb=outFlfb;
			retFlSumm.fb=retFlfb;

			outFlfc=this.getFc(outFlfare,isCombo);
			retFlfc=this.getFc(retFlfare,isCombo);
			outFlSumm.fc=outFlfc;
			retFlSumm.fc=retFlfc;

			outFlsupp=this.getSupp(outFlfare,isCombo);
			retFlsupp=this.getSupp(retFlfare,isCombo);
			outFlSumm.supp=outFlsupp;
			retFlSumm.supp=retFlsupp;

			outFlSumm.sfsfd=sfsfd;
			retFlSumm.sfsfd=sfsfd;

			outFlSumm.foninx = owardIdx.toString();
			retFlSumm.frtinx = returnIdx.toString();
		},

		/**
		 * getCheapFareSelected is used in the below cases
		 * display results in all flights and combotab flow
		 * flight summary
		 * prefreed airline filter
		 */
		getCheapFareSelected : function(flSolution,isCombo){ // TODO cache the faretype once detected
			return (isCombo)? flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd]:flSolution.fare[flSolution.fare.dfd];
		},


		/*getFlightFk : function(flSolution,isCombo){
			var fk;
			if(flSolution.fare.dfd){
				fk = isCombo ? flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd].fk : flSolution.fare[flSolution.fare.dfd].fk;
			} else if(flSolution.fare.SPLRT){
				fk = flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd].fk;
			}
			return fk;
	   },*/

	   getFlightType: function(flSolution, isCombo) {
		   var fType;
		   if(flSolution.fare.dfd){
			   fType = isCombo ? flSolution.fare["SPLRT"].dfd : flSolution.fare.dfd;
		   } else if(flSolution.fare.SPLRT){
			   fType = flSolution.fare["SPLRT"].dfd;
		   }
		   return fType;
	   },

		/*getFlightSavings : function(flSolution,isCombo){
			var savings;
			if(flSolution.fare.dfd){
				savings = isCombo ? flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd].ps : flSolution.fare[flSolution.fare.dfd].ps;
			}else if(flSolution.fare.SPLRT){
				savings = flSolution.fare["SPLRT"][flSolution.fare["SPLRT"].dfd].ps;
			}
			return savings;
		},*/

		/*getFlightPrice : function(flSolution){
			var price;
			if(flSolution.fare.dfd){
				price = flSolution.fare[flSolution.fare.dfd].t ;
			}else if(flSolution.fare.SPLRT){
				price = flSolution.fare.SPLRT[flSolution.fare.SPLRT].t;
			}
			//price = flSolution.fare[flSolution.fare.dft].t ;
			return price;
		},*/

		updateChFLight : function(owardIdx, returnIdx, updatePackagePrice,tripType,_isCombo) {
			CT.tripType = tripType;
			CT.flightsChanged =  false
			//CT.comboDealsFlag => is updated only in the change flights flow.
			if(CT.comboDealsFlag === true){
				var isCombo = true;
			}else{
				var isCombo = false;
			}
			//_isCombo => will be sent only by the preffered Airlines filter.
			if(_isCombo!= null){
				isCombo = _isCombo;
			}

			if(updatePackagePrice !== '')//unchecking main page preferred airlines check boxs.
				$('#ResultContainer_'+CT.settings.currentTab).find("select.airLine").val(0);
			var sfsfd = (_.deserialize(location.search)).sfsfd ? true : false;
			var currentTab = CT.settings.currentTab,
				data =  CT.masterJson.get(),

				currentTab = CT.settings.currentTab,
				searchJson = CT.masterJson.get(),
				//isCombo = CT.FlightSolution.isComboCombination(owardIdx,returnIdx,searchJson.fl),
				// isCombo should always be false for DP flow , as we are not showing the combo flight in the show-all flights container.

				flMapping = searchJson.fl.mapping,
				dpPricetemplate = $('#DpTotalPriceTpl').html(),
				dpTemplate =  $('#DpAirTpl').html(),
				liElem = $(".listView li.listItem"),
				fareIndex = {"onward":owardIdx,"return":returnIdx},
				that = this,
				onwardPrice = that.getCheapFareSelected(searchJson.fl.mapping.onward[owardIdx],isCombo),

				returnPrice = (CT.tripType === "domRt") ? (that.getCheapFareSelected(searchJson.fl.mapping['return'][returnIdx],isCombo)):(null),

				priceOffset = CT.tripType === "domRt" ? ({"onward":onwardPrice.pr,"return":returnPrice.pr}):({"onward":onwardPrice.pr}),
				currOWOffset = that.getCheapFareSelected(searchJson.fl.mapping.onward[owardIdx],isCombo),
				currRTOffset = CT.tripType === "domRt" ? (that.getCheapFareSelected(searchJson.fl.mapping['return'][returnIdx],isCombo)):(null),
				currOffset = CT.tripType === "domRt" ? (currOWOffset.ps + currRTOffset.ps):(currOWOffset.ps + 0),
				currentPage = $('#ResultContainer_'+ currentTab);
				if(currentPage.find(".selChangeFlight").length > 0){
					var liObj = currentPage.find(".selChangeFlight"),
					$hotelLi = $('#' + liObj.attr('id')),
					flObj =  liObj.find(".flightInfo");
				}else{
					var flObj = currentPage.find(".flightInfo");
				}

				var prevSavingsOWIndex = $(flObj).find(".summary:first").attr("data-foninx"),
				prevSavingsRTIndex =  $(flObj).find(".summary:last").attr("data-frtinx");
				/*if(CT.comboDealsFlag === true){
					var isPrevCombo = CT.FlightSolution.isComboCombination(prevSavingsOWIndex,prevSavingsRTIndex,searchJson.fl);
				}else{
					var isPrevCombo = isCombo;
				}*/
				var isPrevCombo = CT.comboDealsFlag === true ? CT.FlightSolution.isComboCombination(prevSavingsOWIndex,prevSavingsRTIndex,searchJson.fl):CT.FlightSolution.isComboCombination(prevSavingsOWIndex,prevSavingsRTIndex,searchJson.fl);
				var prevSavingsOW = that.getCheapFareSelected(searchJson.fl.mapping.onward[prevSavingsOWIndex],isPrevCombo),
				prevSavingsRT = CT.tripType === "domRt" ? (that.getCheapFareSelected(searchJson.fl.mapping['return'][prevSavingsRTIndex],isPrevCombo)):(null),
				prevSavings = CT.tripType === "domRt" ? (prevSavingsOW.ps + prevSavingsRT.ps):(prevSavingsOW.ps + 0);

				savingsOffset = currOffset - prevSavings ;

				//isCombo = CT.FlightSolution.isComboCombination(owardIdx,returnIdx,searchJson.fl),
				owdPrice = that.getCheapFareSelected(searchJson.fl.mapping.onward[owardIdx],isCombo),
				retPrice = CT.tripType === "domRt" ? (that.getCheapFareSelected(searchJson.fl.mapping['return'][returnIdx],isCombo)):(null);
				updatePackagePrice = CT.tripType === "domRt" ? (parseInt(owdPrice.pr) + parseInt(retPrice.pr)):(parseInt(owdPrice.pr) + 0);

				this.updateFlightMasterJson(searchJson.fl.mapping,fareIndex,priceOffset);

				this.updateHotelMasterJsonPrice(searchJson.ht,updatePackagePrice);

				this.updateHotelMasterJsonSavings(searchJson.ht, savingsOffset);

				this.flightDebuggerOptions(searchJson.fl,owardIdx,returnIdx,isCombo);




//			_.each(liElem, function(el, idx) {
//				$el= $(el);
//				onwardReturnFl = [];
//				hidx = $el.attr("data-htinx");
//
//				outFlSumm = searchJson.fl.mapping.onward[owardIdx].summary;
//				retFlSumm = searchJson.fl.mapping['return'][returnIdx].summary;
//
//				outFlfare=searchJson.fl.mapping.onward[owardIdx].fare;
//				retFlfare=searchJson.fl.mapping['return'][returnIdx].fare;
//
//				outFlfb=this.getFb(outFlfare);
//				retFlfb=this.getFb(retFlfare);
//				outFlSumm.fb=outFlfb;
//				retFlSumm.fb=retFlfb;
//
//				outFlfc=this.getFc(outFlfare);
//				retFlfc=this.getFc(retFlfare);
//				outFlSumm.fc=outFlfc;
//				retFlSumm.fc=retFlfc;
//
//				outFlsupp=this.getSupp(outFlfare);
//				retFlsupp=this.getSupp(retFlfare);
//				outFlSumm.supp=outFlsupp;
//				retFlSumm.supp=retFlsupp;
//
//				outFlSumm.sfsfd=sfsfd;
//				retFlSumm.sfsfd=sfsfd;
//
//				outFlSumm.foninx = owardIdx.toString();
//				retFlSumm.frtinx = returnIdx.toString();
//
//				onwardReturnFl.push(outFlSumm);
//				onwardReturnFl.push(retFlSumm);
//
//				flhtml = Mustache.to_html(dpTemplate, { content: onwardReturnFl });
//				$el.find(".flightInfo .summary").remove();
//				$el.find(".flightInfo").prepend(flhtml);
//
//				pkgFare= searchJson.ht[hidx].priceInfo.pf;
//				pkgSaving = searchJson.ht[hidx].priceInfo.ps;
//				airpf= searchJson.ht[hidx].priceInfo.airpf;
//				airps = searchJson.ht[hidx].priceInfo.airps;
//				hotelpf= searchJson.ht[hidx].priceInfo.hotelpf;
//				hotelps = searchJson.ht[hidx].priceInfo.hotelps;
//
//				phtml = Mustache.to_html(dpPricetemplate, this.calFormatPrice(undefined, pkgFare, pkgSaving, airpf, airps, hotelpf, hotelps, sfsfd));
//				$el.find(".price").html(phtml);
//			}, this);

			//updating flight cheap con and crt index's
			if(isCombo){
				CT.masterJson.get().fl.con = owardIdx+"-SPLRT-"+searchJson.fl.mapping.onward[owardIdx].fare.SPLRT.dfd;
				CT.masterJson.get().fl.crt = returnIdx+"-SPLRT-"+searchJson.fl.mapping['return'][returnIdx].fare.SPLRT.dfd;
			}else{
				CT.masterJson.get().fl.con = owardIdx+"-"+searchJson.fl.mapping.onward[owardIdx].fare.dfd;
				CT.masterJson.get().fl.crt = returnIdx+"-"+searchJson.fl.mapping['return'][returnIdx].fare.dfd;

			}


			CT.fire("airlinesfilters.ready",[CT.masterJson.get()]);

			CT.utils.showLoader("flight");
			if($hotelLi && $hotelLi.length > 0) {
				  setTimeout(function() {
					  $('body,html').scrollTop($hotelLi.offset().top);
					  $hotelLi.addClass('highlightMe');
				  }, 3000);
				  setTimeout(function() { $hotelLi.removeClass('highlightMe'); }, 7000);
			}
		},

		isComboCombination: function(off, rff, flData) {

			outSolution = flData.mapping.onward[off];
			retSolution = flData.mapping['return'][rff];

			if(outSolution.fare.SPLRT == undefined || retSolution.fare.SPLRT == undefined) {
				return false;
			}
			outSpFareObj = outSolution.fare.SPLRT;
			outSpFareObj = outSpFareObj[outSpFareObj["dfd"]]

			retSpFareObj = retSolution.fare.SPLRT;
			retSpFareObj = retSpFareObj[retSpFareObj["dfd"]]

			if(outSpFareObj.fk && outSpFareObj.fk.indexOf("AMADEUS") != -1 && retSpFareObj.fk && retSpFareObj.fk.indexOf("AMADEUS") != -1) {
				var returnValue = false,
					out_aircodes = [],
					out_aircodes_str = "",
					ret_aircodes = [],
					ret_aircodes_str = "";

				_.forEach(outSolution.content, function(os, index) {
					airNum = os.ac.split(" ")[1];
					out_aircodes.push(airNum);
				});

				out_aircodes = _.uniq(out_aircodes);
				out_aircodes_str = out_aircodes.join("$");

				_.forEach(retSolution.content, function(rs, index) {
					airNum = rs.ac.split(" ")[1];
					ret_aircodes.push(airNum);
				});

				ret_aircodes = _.uniq(ret_aircodes);
				ret_aircodes_str = ret_aircodes.join("$");


				if(retSpFareObj.cc.split(",").indexOf(out_aircodes_str)!=-1){
					returnValue = true;
				}else{
					returnValue = false;
				}

				if(returnValue){
					if(outSpFareObj.cc.split(",").indexOf(ret_aircodes_str)!=-1){
						returnValue = true;
					}else{
						returnValue = false;
					}
				}

				//return returnValue;
			} else {
				if(outSpFareObj.cc == retSpFareObj.cc){
					returnValue =  true;
				}else{
					returnValue =  false;
				}
			}
			if(returnValue){
				returnValue = outSpFareObj.pr + retSpFareObj.pr < outSolution.fare[outSolution.fare.dfd].pr + retSolution.fare[retSolution.fare.dfd].pr

			}
			return returnValue;
		},


		getFb: function(fare,isCombo) {
			var selectedFare = (isCombo)?fare["SPLRT"][fare["SPLRT"].dfd]:fare[fare.dfd];
			return selectedFare.fb;
		},

		getFc: function(fare,isCombo) {
			var selectedFare = (isCombo)?fare["SPLRT"][fare["SPLRT"].dfd]:fare[fare.dfd];
			return selectedFare.fk.split('|')[2].split('_')[1]
		},

		getSupp: function(fare,isCombo) {
			var selectedFare = (isCombo)?fare["SPLRT"][fare["SPLRT"].dfd]:fare[fare.dfd];
			return selectedFare.fk.split('|')[0].split('_')[1]
		},

		areSelectedFlightsACombo:function(){
			var searchJson = CT.masterJson.get().fl;
			var con = searchJson.con,
			crt = searchJson.crt,
			conObj = {},
			crtObj = {},
			comboUtil={};

			if(con.indexOf("SPLRT") != -1 && crt.indexOf("SPLRT") != -1){

				// No Need of the below check , because if both the flights have SPLRT, they will be combinable
				//if(window.parent.CT.FlightSolution.isComboCombination(con.split("-")[0],crt.split("-")[0],searchJson)){
					conObj = searchJson.mapping.onward[con.split("-")[0]];
					crtObj = searchJson.mapping["return"][crt.split("-")[0]];
					comboUtil.alCode = conObj.content[0].alCode; // taking only onward flight and the first leg assuming the a combo flight is always in a multi airline


					return comboUtil;

				//}else{
				//	return false;
				//}
			}else{
				return false;
			}
		},

		/*
		 * @desc : This function calculates the savings, original price and formats each for display
		 * @param : hotel - json object - if hotel is passed then hotel will be modified and returned, else a new object will be created and returned
		 * @param : tot - actual price in integer
		 * @param : dis - discount price in integer
		 */
		calFormatPrice: function(hotel, tot, dis, airpf, airps, hotelpf, hotelps, sfsfd) {
			var dis = parseInt(dis) || 0, tot = parseInt(tot), hotel = hotel || {};
			if(dis > 0) {
				hotel.discPerc = CT.utils.helperFunctions.calDiscountPercent(dis, tot);
				hotel.discPercInt = Int(hotel.discPerc);
				hotel.oamt = Mustache.to_html($("#CurrencyFormatTpl").html(), CT.utils.formatForCurrency(tot + dis, false, null, true));
				hotel.sav = Mustache.to_html($("#CurrencyFormatTpl").html(), CT.utils.formatForCurrency(dis, false, null, true));
			}else{
				hotel.oamt = "";
				hotel.sav = "";
			}
			hotel.totfmt = Mustache.to_html($("#CurrencyFormatTpl").html(), CT.utils.formatForCurrency(tot, false, null, true));
			hotel.discPerc = "0";
			hotel.discPercInt = "0";

			if (airpf !== undefined) hotel.airpf=airpf;
			if (airps !== undefined) hotel.airps=airps;
			if (hotelpf !== undefined) hotel.hotelpf=hotelpf;
			if (hotelps !== undefined) hotel.hotelps=CT.utils.formatForCurrency(hotelps, false, null, true).fmtPrice;

			if (sfsfd  !== undefined) hotel.sfsfd=sfsfd;

			return hotel;
		},

		getFlightSummaryMarkup: function(onwardIndex, returnIndex, mJson) {
			var onwardReturnFl = [],
			mJson = mJson || CT.masterJson.get(); //TODO :change to masterJson.get() - karthik

			onwardReturnFl.push(mJson.fl.mapping.onward[onwardIndex].summary);
			onwardReturnFl.push(mJson.fl.mapping['return'][returnIndex].summary);

			return Mustache.to_html($('#FlightSummaryCpTpl').html(), { content: onwardReturnFl });
		},

		confirmUserForClose : function (){
			if(CT.flightsChanged == true || CT.roomTypeChanged == true){
				var val=confirm("Do you want to discard your changes");
				if (val==true){
					return true;
				}else{
				  return false;
				}
			}else{
				return true;
			}
		},
		getHotelSummaryMarkup: function(hotelIndex, selectedRmtc, mJson) {
			var mJson = mJson || CT.masterJson.get(), renderObj = {}, tmp; //TODO :change to masterJson.get() - karthik

			renderObj.nm = mJson.ht[hotelIndex].nm;
			renderObj.im = mJson.ht[hotelIndex].im;
			renderObj.shortID = mJson.ht[hotelIndex].shortID;
			renderObj.id = mJson.ht[hotelIndex].id;
			tmp = CT.cache[CT.settings.currentTab].searchParams.processed;
			renderObj.destination = tmp.destination;
			renderObj.num_rooms = tmp.num_rooms;
			renderObj.num_nights = tmp.num_nights;
			_.forEach(mJson.ht[hotelIndex].priceInfo.rms, function(rms) {
				if(rms.rmtc == selectedRmtc)
					renderObj.rmtp = rms.rm;
			});

			return Mustache.to_html($('#HotelSummaryTpl').html(), renderObj);
		}

	};

	return CT.FlightSolution
}, CT)
;
